import { render } from "./manage_questions.html?vue&type=template&id=72a48dd4&external"
import script from "./manage_questions.js?vue&type=script&lang=js&external"
export * from "./manage_questions.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__